import { AlertEventLog } from 'es/app/business-logic/domain-models/Alerts';
import EntityStore from 'es/app/store/EntityStore';
import Guid from 'es/core/types/Guid';
import { computed, makeObservable } from 'mobx';

interface IAlertEventLogStore {
    id: Guid;
    logs: AlertEventLog[];
}

export default class AlertEventDetailsStore extends EntityStore<IAlertEventLogStore> {
    constructor() {
        super();
        makeObservable(this, {
            alerts: computed,
        });
    }

    public get alerts(): IAlertEventLogStore[] {
        return this.entities;
    }
}
